import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ValidPassModel } from '@bo-client/activation-management/shared/models/validPassWithUsersModel';
import { AreaTypesModel } from '@bo-client/shared/models/areaTypes';
import { AG_GRID_LOCALE_DE } from '@ag-grid-community/locale';
import { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-valid-passes-modal',
  templateUrl: './valid-passes-modal.component.html',
  styleUrls: ['./valid-passes-modal.component.scss']
})
export class ValidPassesModalComponent {
  matDialogRef = inject(MatDialogRef<ValidPassesModalComponent, ValidPassModel | null>);
  readonly data: {
    areaType: AreaTypesModel;
    validPasses: ValidPassModel[];
  } = inject(MAT_DIALOG_DATA);

  columnDefs: ColDef<ValidPassModel>[] = [
    { field: 'passNumber', headerName: 'Ausweis-Nummer' },
    { field: 'userName', headerName: 'Name' },
    { field: 'companyLocationName', headerName: 'Betriebsbereich' }
  ];

  defaultColDef: ColDef = {
    sortable: true,
    filter: false,
    resizable: true,
    flex: 1
  };

  onCancel(): void {
    this.matDialogRef.close(null);
  }

  onSelectPass(pass: ValidPassModel): void {
    this.matDialogRef.close(pass);
  }

  protected readonly localeText = AG_GRID_LOCALE_DE;
}
